import React, { useEffect, useState } from "react";
import Box, { Item } from 'devextreme-react/box';
import List from 'devextreme-react/list';

export default function RecogResultSideMenu({ job, clickFunction }) {
    const [selectedIdx, setSelectedIdx] = useState(0);
    const optionChange = (e) => {
        if (e.name == "selectedIndex")
            setSelectedIdx(e.value);
    };

    useEffect(() => {
        if (typeof job != "undefined" && job != null) {
            if (job.length > 0 && typeof job[0].img != "undefined" && job[0].img != null) {
                clickFunction(job[0].name, job[0].idx);
            }
        }
    }, [job]);

    useEffect(() => {
        if (typeof job != "undefined" && job != null) {
            clickFunction(job[selectedIdx].name, job[selectedIdx].idx);
        }
    }, [selectedIdx]);

    return(
            <Box
                direction = "col"
                width = "100%"
                height = "100%"
            >
                <Item ratio={1}>
                    <Box
                        height="100%"
                        crossAlign="center"
                    >
                        <Item ratio={1}>
                        </Item>
                    </Box>
                </Item>
                <Item ratio={30}>
                    <Box
                        direction="col"
                        width="100%"
                        height="100%"
                        crossAlign=""
                        style={{
                            borderWidth: 1,
                            borderStyle: "solid",
                            borderColor: "#3cbab2"
                        }}
                    >
                        <Item ratio={1}>
                            <List
                            height="100%"
                            dataSource={job}
                            keyExpr="name"
                            itemRender={ImageListItem}
                            scrollingEnabled={true}
                            selectionMode="single"
                            selectedIndex={selectedIdx}
                            onOptionChanged={optionChange}
                            />
                        </Item>
                    </Box>
                </Item>
            </Box>
		);
}

function ImageListItem(item) {
    return (
        <img
            width="100%"
            src={item.img}
            style={{
                borderWidth: 1,
                borderStyle: "solid"
            }}
        />
    );
}